// Legacy caps instrument-type images at 400×400 px (REBUILD-503). The server is the real
// gate (InstrumentTypes::ImageService#validate_dimensions!); the client check that uses these
// helpers is UX — immediate feedback that avoids a round trip for an obviously-oversize file.
export const MAX_IMAGE_DIMENSION_PX = 400

export interface ImageDimensions {
  width: number
  height: number
}

// Reads an image file's natural pixel dimensions via an object URL. Resolves null when the
// file can't be decoded as an image (the server/MIME check handles that case).
export const readImageDimensions = (file: File): Promise<ImageDimensions | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const image = new Image()
    image.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: image.naturalWidth, height: image.naturalHeight })
    }
    image.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(null)
    }
    image.src = url
  })

export const exceedsMaxDimensions = (dimensions: ImageDimensions | null): boolean =>
  dimensions !== null &&
  (dimensions.width > MAX_IMAGE_DIMENSION_PX || dimensions.height > MAX_IMAGE_DIMENSION_PX)
